import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface UserDataStorageConfig {
    deferWrite: boolean;
    userStorageEndpoint: string;
}

@Injectable({
    providedIn: 'root'
})
export class UserDataStorageConfigService {
    public readonly config: UserDataStorageConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<UserDataStorageConfig>('userStorageConfig');
    }
}
